<template>
	<div class="auth side side-blank">
		<div class="container">
			<div class="logo"></div>
			<h1>{{ $t('base.idicare.slogan_1') }}</h1>
			<h2>{{ $t('base.idicare.slogan_2') }}</h2>
		</div>
		<auth-static-content-links/>
		<locale-flag-selector/>
	</div>
</template>

<script>
import AuthStaticContentLinks from './AuthStaticContentLinks'
import LocaleFlagSelector from '@/components/i18n/LocaleFlagSelector'
export default {
	components: {
		AuthStaticContentLinks,
		LocaleFlagSelector
	}
}
</script>



// WEBPACK FOOTER //
// src/components/auth/SideBlank.vue